import Vue from 'vue'
import VueResource from 'vue-resource'
import store from 'src/vuex/store'

const isPro = store.state.isPro
const API_ROOT = isPro ? 'https://app11007.huoban.com/api/' : 'http://app11007.dev.huoban.com/api/'

Vue.use(VueResource)

// HTTP相关
Vue.http.options.crossOrigin = true
Vue.http.options.xhr = {withCredentials: true}

Vue.http.interceptors.push({
  request(request) {
    // 这里对请求体进行处理
    request.headers = request.headers || {}
    if (!request.headers.Authorization) {
      if (store.state.auth.ticket && (request.url.indexOf(API_ROOT) === 0)) {
        request.headers['X-Huoban-Ticket'] = store.state.auth.ticket
        request.headers['X-Huoban-App-Id'] = store.state.auth.appId
        request.headers['X-Huoban-Table-Id'] = store.state.auth.tableId
      } else {
        request.headers['X-Huoban-E'] = `${store.router.app.$route.params.id}`
      }
    }
    return request
  },
  response(response) {
    return response
  }
})

// ---- todo resources
export const TodoResource = {
  getConfigInfo() {
    return Vue.http.get(API_ROOT + 'config')
  },
  updateConfigInfo(data) {
    return Vue.http.put(API_ROOT + 'config', data)
  },
  getTodos() {
    return Vue.http.get(API_ROOT + 'todos')
  },
  createTodo(data) {
    return Vue.http.post(API_ROOT + 'todo', data)
  },
  updateTodo(id, data) {
    return Vue.http.put(API_ROOT + `todo/${id}`, data)
  },
  deleteTodo(id) {
    return Vue.http.delete(API_ROOT + `todo/${id}`)
  },
  updateTodoOrder(data) {
    return Vue.http.post(API_ROOT + 'order/todos', data)
  },
  wxAjax() {
    return Vue.http.post('https://api.huoban.com/v1/auth/wechat/mp_signature', JSON.stringify({url: location.href}), {
      headers: {
        Authorization: 'Bearer y1npyvEPe6iM9xiZzjr69bn81XXlPRnHT0xrcZtP'
      }
    })
  }
}

// ---- stat resources
export const StatResource = {
  statUserAction(data) {
    let StatOptions = {
      headers: {
        'X-Huoban-Ticket': store.state.auth.ticket
      }
    }
    return Vue.http.post('https://api.huoban.com/v2/log', data, StatOptions)
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/resource.js
 **/